import script from "./LeadCustomerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadCustomerModal.vue?vue&type=script&setup=true&lang=js"

import "./LeadCustomerModal.vue?vue&type=style&index=0&id=56d855c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d855c1"]])

export default __exports__